import { Component, OnDestroy, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { GenerateAnnualDeclarationPdf } from 'app/company/form/annual-declaration-form/shared/state/annual-declaration.actions';
import { AnnualDeclarationState } from 'app/company/form/annual-declaration-form/shared/state/annual-declaration.state';
import { FormStatus } from 'app/company/shared/model/company.model';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { AnnualDeclarationFormCollection } from '~app/company/form/annual-declaration-form/shared/model/annual-declaration.model';
import { CompanyIdentification, CompanyRepresentativeSubstitute } from '../../company/form/annual-declaration-form/shared/model/company-identification.model';
import { AnnualDeclarationFormFirebaseService, VersionType } from '../../company/form/annual-declaration-form/shared/service/annual-declaration-form-firebase.service';
import { ReceiptActions, ReceiptState } from './state';
import { ReceiptModel } from './state/receipt.model';

@Component({
    selector: 'odq-receipt',
    templateUrl: './receipt.component.html',
    styleUrls: ['./receipt.component.scss'],
    standalone: false
})
export class ReceiptComponent implements OnInit, OnDestroy {

  @Select(AnnualDeclarationState.companyRepresentativeSubstitute(VersionType.Current))
  representativeSubstitute$: Observable<CompanyRepresentativeSubstitute>;

  @Select(AnnualDeclarationState.companyIdentification)
  companyIdentification$: Observable<CompanyIdentification>;

  @Select(AnnualDeclarationState.legalEntityNumber)
  legalEntityNumber$: Observable<string>;

  @Select(AnnualDeclarationState.formCollection)
  formCollection$: Observable<AnnualDeclarationFormCollection>;

  @Select(AnnualDeclarationState.selectedLegalEntityId)
  selectedLegalEntityId$: Observable<string>;

  isFormCompleted$ = new Subject<boolean>();
  isSummaryDownloading$: Observable<boolean>;

  @Select(AnnualDeclarationState.year)
  year$: Observable<number>;

  receipt$ = this.store.select<ReceiptModel>(ReceiptState.receipt);
  formStatus = FormStatus;

  receiptModel: ReceiptModel;
  isAnnualDeclaration = false;
  isEndOfPractice = false;
  destroy$ = new Subject<void>();
  legalEntityId: string;
  year: number;

  constructor(
    private store: Store,
    private annualDeclarationFormFirebaseService: AnnualDeclarationFormFirebaseService
  ) { }

  ngOnInit() {

    this.selectedLegalEntityId$.pipe(takeUntil(this.destroy$))
      .subscribe((data) => { this.legalEntityId = data; });

    this.year$.pipe(takeUntil(this.destroy$))
      .subscribe((data) => { this.year = data; });

    this.isSummaryDownloading$ = this.formCollection$.pipe(
      map(col => col?.isSummaryDownloading),
      takeUntil(this.destroy$)
    );

      this.receipt$.pipe(takeUntil(this.destroy$))
      .subscribe((data) => 
        { 
          this.receiptModel = data; 
          this.isAnnualDeclaration = this.receiptModel.metadata.formType === 'AN';
          this.isEndOfPractice = this.receiptModel.metadata.formType === 'FIN';
        });

    this.monitorFormCompleted();
  }

  monitorFormCompleted() {
    this.annualDeclarationFormFirebaseService
      .getAnnualDeclarationFormCollection(this.legalEntityId, this.year)
      .pipe(takeUntil(this.destroy$))
      .subscribe((collection) => {
        if (collection.state === FormStatus.Completed) {
          this.isFormCompleted$.next(true);
        }
      });
  }


  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.store.dispatch(new ReceiptActions.RemoveReceipt());
  }

  downloadPdf() {
    this.store.dispatch(new GenerateAnnualDeclarationPdf());

  }
}
